// extracted by mini-css-extract-plugin
export default {"skipToContent":"skipToContent_G6ar"};